import baseAPI from '@/api/base';
import { EditBank, GetBank, RegisterBank } from '@/dtos/bank.dto';
import {
  DELETE_BANK_URL,
  EDIT_BANK_URL,
  GET_BANK_URL,
  REGISTER_BANK_URL,
  TOGGLE_BANK_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Bank {
  static getBanks = async (getBank: GetBank): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_BANK_URL, {
      params: getBank,
    });
    console.log('response', response);
    return response;
  };

  static registerBank = async (
    registerBank: RegisterBank
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_BANK_URL, {
      ...registerBank,
    });
    console.log('response', response);
    return response;
  };

  static editBank = async (editBank: EditBank): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_BANK_URL, {
      ...editBank,
    });
    return response;
  };

  static toggleBankIsActive = async (
    editBank: EditBank
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_BANK_IS_ACTIVE_URL,
      {
        ...editBank,
      }
    );
    return response;
  };

  static deleteBank = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_BANK_URL}/${userId}`
    );
    return response;
  };
}

export default Bank;
